import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import Header from "../components/Header";
import getALink from "../assets/getaLink.jpg";
function Welcome() {
  return (
    <>
      <Header />
      <Box
        sx={
          {
            // height: "50vh",
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "space-around",
            // alignItems: "center",
          }
        }
      >
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Card
              sx={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#fcf6cc",
                height: "20vh",
                fontSize: 25,
                margin:3
              }}
            >
              <CardContent>Please obtain a valid link and try again</CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <img src={getALink} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Welcome;
